export const EXTERNAL_FLOW = 'url'
export const HOURLY_FLOW = 'hourly_flow'
export const MONTHLY_FLOW = 'monthly_flow'
